import {
  GET_CONFIGURATION_BY_COMPANY_ID,
  GET_CONFIGURATION_WITH_SETTING_DATA,
  GET_ACTIVITY_CONFIGURATION_SETTING_MAPPING,
  GET_HEADERNAME_BY_COMPANY_ID,
  STORE_CONFIGURATION_ID,
  REMOVE_CONFIGURATION_ID,
  WORKFLOW_HEADER_NAME,
  RESET_REDUX_STATE,
  SET_WORKFLOW
} from "../constants";

const initialValue = {
  configurationData: [],
  configurationWithSettingData: '',
  configurationSettingMappingData: [],
  headerList: [],
  configurationID: '',
  configurationHeaderName : '',
  workflow: {}
};

const configurationReducer = (state = initialValue, action) => {
  const { type, payload } = action;
  switch (type) {
    case GET_CONFIGURATION_BY_COMPANY_ID: {
      return {
        ...state,
        configurationData: payload,
      };
    }

    case GET_CONFIGURATION_WITH_SETTING_DATA: {
      return {
        ...state,
        configurationWithSettingData: payload,
      };
    }

    case GET_ACTIVITY_CONFIGURATION_SETTING_MAPPING: {
      return {
        ...state,
        configurationSettingMappingData: payload,
      };
    }

    case GET_HEADERNAME_BY_COMPANY_ID: {
      return {
        ...state,
        headerList: payload
      }
    }
    
    case STORE_CONFIGURATION_ID: {
      return {
        ...state,
        configurationID: payload
      }
    }

    case REMOVE_CONFIGURATION_ID: {
      return {
        ...state,
        configurationID: '',
        configurationWithSettingData: ''
      }
    }

    case WORKFLOW_HEADER_NAME: {
      return {
        ...state, 
        configurationHeaderName: payload
      }
    }

    case SET_WORKFLOW: {
      return {
        ...state,
        workflow: payload
      }
    }

    case RESET_REDUX_STATE: {
      return initialValue
    }

    default:
      return state;
  }
};

export default configurationReducer;
